import { http } from '@/http/axios.js'

export function getQiniuToken() {
  return http({
    url: `/api/client/file/misc/getUploadConf`,
    method: 'get'
  })
}
